"use client";

const SIGN_IN_URL = "https://application.amityonline.com/admission/home/signin";

export default function AffiliateExistingLeadPopUp({
  onClose,
}: {
  onClose: () => void;
}) {
  return (
    <div className="absolute inset-0 z-10 bg-black/40 flex items-center justify-center rounded-sm">
      <div className="bg-white rounded-lg px-10 py-8 text-center shadow-xl w-[85%]">
        <div className="flex items-center justify-center mb-4">
          <div className="flex items-center justify-center w-14 h-14 rounded-full border-2 border-green-300">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
        </div>

        <p className="text-[#333] font-bold text-lg mb-6">Already Exist</p>

        <div className="flex gap-2 justify-center">
          <button
            onClick={onClose}
            className="px-6 py-2 rounded-md border border-gray-300 text-sm text-gray-600 bg-white hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={() => { window.location.href = SIGN_IN_URL; }}
            className="px-6 py-2 rounded-md text-sm text-white bg-[#87CEEB] hover:opacity-90"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}
